import React, { useContext } from 'react'
import TfBreadcrumbs from '../../../components/Common/TfBreadcrumbs'
import { TourContext } from "../../../components/Common/TourGuide/TourGuide";
import { useNavigate } from 'react-router-dom';

export default function TopBreadcrumbs({ breadcrumbs, data, tourAdress, isBackRequired = true }) {

    const { onStartTour } = useContext(TourContext);
    const navigate = useNavigate();
    /*
    
    */
    return (
        <>
            <div className="d-flex align-items-center">
                {isBackRequired && <button
                    type="button"
                    className="btn border me-3 mb-3"
                    onClick={() => navigate(-1)}>
                    Back
                </button>}
                

                <div className="d-flex align-items-center w-100">
                    <div className="tf_top_breadcrumb_rate_wrap w-100">
                        <div className="d-flex align-items-center gap-2">
                            <TfBreadcrumbs breadcrumb={breadcrumbs} />
                            <div onClick={() => onStartTour(tourAdress)}>
                                <i className="fas fa-info-circle" style={{ color: "#0056b3", size: "24px" }}></i>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}
